// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

const config = {
  appId: '0664c9f5-48e2-455b-8286-76877e7a02d0',
  redirectUri: 'https://clm365wordaddins.azurewebsites.net',
  scopes: [
    'user.read',
    'mailboxsettings.read',
    'calendars.readwrite',
    'Sites.Read.All',
  ]
};

export default config;
